import {
  PaymentAttemptStatus,
  PaymentHandoffInstruction,
  PaymentLaunchContext,
  PaymentProcessor,
  TmPaymentRequest,
} from '@common/entities';
import { get, post } from 'config/api/config';

import { Applicant } from 'types/applicant';

import { StripePaymentRequest } from './payment-intl';

export interface PaymentAttemptBootstrap {
  readonly attemptId: string;
  readonly applicant: Applicant;
  readonly responseId: string;
  readonly viewerPath: string;
  readonly launchContext: PaymentLaunchContext;
  readonly paymentId: string | null;
  readonly stripePaymentKey: string | null;
  readonly status: PaymentAttemptStatus;
  readonly mayContinue?: boolean;
  readonly instruction?: PaymentHandoffInstruction;
  readonly payment?: Omit<StripePaymentRequest, 'websiteHost'>;
}

export async function createPaymentHandoff(
  payment: (Omit<StripePaymentRequest, 'websiteHost'> | Omit<TmPaymentRequest, 'websiteHost'>) & {
    viewerPath: string;
  },
  responseId: string,
  launchContext: PaymentLaunchContext,
  processor: PaymentProcessor = 'stripe',
) {
  return post<{ attemptId: string; handoffUrl: string }>('viewer/payment-handoffs', {
    processor,
    payment,
    responseId,
    launchContext,
  });
}

export async function continuePaymentHandoff(id: string) {
  return post<{ continuePayment: boolean }>(
    `viewer/payment-handoffs/${encodeURIComponent(id)}/continue`,
  );
}

export async function bootstrapPaymentAttempt(id: string, viewerPath: string) {
  return get<PaymentAttemptBootstrap>(`viewer/payment-attempts/${encodeURIComponent(id)}`, {
    params: { viewerPath },
  });
}

export async function getPendingPaymentAttempt(responseId: string) {
  return get<{ attemptId: string; status: PaymentAttemptStatus } | null>(
    'viewer/payment-attempts',
    {
      params: { responseId },
    },
  );
}

export async function abandonPaymentAttempt(id: string) {
  return post<{ viewerPath: string }>(`viewer/payment-attempts/${encodeURIComponent(id)}/abandon`);
}

export async function startPaymentCheckout(id: string) {
  return post<{ checkoutSessionUrl: string }>(
    `viewer/payment-attempts/${encodeURIComponent(id)}/checkout`,
  );
}

export async function verifyPaymentAttempt(id: string, operation: 'success' | 'cancel') {
  return post(`viewer/payment-attempts/${encodeURIComponent(id)}/verify`, { operation });
}
